import * as Yup from "yup";

export const ChallengeSchema = () => {
  const coverImageValidation = Yup.mixed<any>()
    .nullable()
    .required("Cover Image is required");
  const mediaValidation = Yup.mixed<any>()
    .nullable()
    .required("Media is required");
  const startDateValidation = Yup.mixed<any>()
    .nullable()
    .required("Start date is required");

  const endDateValidation = Yup.mixed<any>()
    .nullable()
    .required("End date is required")
    .test(
      "date-min",
      "End date must be later than start date",
      function (value, { parent }) {
        // Check if start date is provided before comparing with end date
        if (parent.startDate && value) {
          return value.getTime() > parent.startDate.getTime();
        }
        return true; // Return true if start date or end date is not provided
      }
    );

  const mediaTypeValidation = Yup.string();

  return Yup.object().shape({
    title: Yup.string()
      .required("Title (En) is required")
      .matches(
        /^[a-zA-Z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\s]+$/,
        "Title (En) must contain only English characters"
      ),
    titleAr: Yup.string()
      .required("Title (Ar) is required")
      .matches(
        /^[\u0600-\u06FF\s0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+$/,
        "Title (Ar) must contain only Arabic characters"
      ),
    description: Yup.string()
      .required("Description (En) is required")
      .matches(
        /^[a-zA-Z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\s]+$/,
        "Description (En) must contain only English characters"
      ),
    descriptionAr: Yup.string()
      .required("Description (Ar) is required")
      .matches(
        /^[\u0600-\u06FF\s0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+$/,
        "Description (Ar) must contain only Arabic characters"
      ),
    coverImage: coverImageValidation,
    startDate: startDateValidation,
    endDate: endDateValidation,
    challengeCategory: Yup.number()
      .required("Challenge Category is required")
      .positive("Please select challenge category"),
    type: mediaTypeValidation,
    media: mediaValidation,
    published: Yup.boolean(),
  });
};
